module.exports = __webpack_public_path__ + "static/media/plantMom.1f7b4c47.jpeg";